export const mdl14Urls = {
  calculatorURL: 'mdl14/calculator/chzMaterials',
  ValidateCommercialCreditURL: 'mdl14/thirdparty/execute',
}
